import React, { useEffect, forwardRef, useState } from 'react';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import moment from "moment";
import "moment/locale/es";

import Loader from "components/Loader/Loader";

import { Redirect } from 'react-router-dom';

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const columns = [
    { id: 'Folio', label: 'Folio', minWidth: 100 },
    { id: 'Nombre', label: 'Nombre', minWidth: 100 },
    { id: 'Celular', label: 'Celular', minWidth: 100 },
    { id: 'Correo', label: 'Correo', minWidth: 100 },
    { id: 'NombreCapturista', label: 'Capturista', minWidth: 100 }
];

function Captura(){
    const [capturas, setCapturas] = useState([]);
    const [respuestas, setRespuestas] = useState([]);
    const [respuestasOriginales, setRespuestasOriginales] = useState([]);
    const [preguntas, setPreguntas] = useState([]);
    const [respuestasEnviar, setRespuestasEnviar] = useState([]);

    const [color, setColor] = useState("");
    const [message, setMessage] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [load, setLoad] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogSend, setDialogSend] = useState(false);

    const [IdCaptura, setIdCaptura] = useState("");
    const [Folio, setFolio] = useState("");

    const [Nombre, setNombre] = useState("");
    const [Costo, setCosto] = useState("");
    const [NombreCapturista, setNombreCapturista] = useState("");
    const [Cuenta, setCuenta] = useState("");

    const [Celular, setCelular] = useState("");
    const [ComentarioVenta, setComentarioVenta] = useState("");
    const [FechaCapturista, setFechaCapturista] = useState("");
    const [Calificacion, setCalificacion] = useState(0);

    const [Observaciones, setObservaciones] = useState("");
    const [Total, setTotal] = useState(0);
    const [TotalPreguntas, setTotalPreguntas] = useState("");

    const [tipo, setTipo] = useState('referencia');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);

    const getUser = () => {
        return JSON.parse(localStorage.getItem("userCalidad")).IdUsuario;
    };

    const sendSnackBar = (pmessage, pcolor) => {
        setOpenSnackbar(true);
        setColor(pcolor);
        setMessage(pmessage);
    };

    const selectRow = (e, row) => {
        e.stopPropagation(); 
        e.preventDefault();

        let elemento = capturas.map(element => {
            if(element.IdCaptura === row.IdCaptura)
            {
                element.select = true;
                return element;
            }
            else
            {
                element.select = false;
                return element;
            }
        });

        setCapturas(elemento);
        limpiaValores();

        let cap = elemento.find(item => item.IdCaptura === row.IdCaptura);

        setIdCaptura(cap.IdCaptura);
        setFolio(cap.Folio);

        setNombre(cap.Nombre);
        setCosto(cap.Costo);
        setCuenta(cap.Cuenta);
        setNombreCapturista(cap.NombreCapturista);

        setCelular(cap.Celular);
        setComentarioVenta(cap.Comentario);
        setFechaCapturista(cap.FechaCapturista);

        setObservaciones(cap.Observacion);

        setLoad(true);

        Login()
        .then(result => {
            let data = {
                IdCaptura: parseInt(row.IdCaptura)
            };

            ObtieneRespuestas(data, result.token)
            .then(result => {
                let nRespuestas = [...respuestas];

                setRespuestasOriginales(result.preguntas);

                result.preguntas.map((item) => {
                    if(item.Respuesta === 1){
                        nRespuestas[item.IdPreguntas - 1].s = true;
                    } else if(item.Respuesta === 2) {
                        nRespuestas[item.IdPreguntas - 1].n = true;
                    } else{
                        nRespuestas[item.IdPreguntas - 1].na = true;
                    }
                });

                setRespuestas(nRespuestas);

                let total = 0;
                nRespuestas.map((item) => {
                    if(item.s || item.na){
                        total = total + item.calificacion;
                    }
                });
                setCalificacion(total < 0 ? 0 : total);
        
                setLoad(false);
            }).catch(error => sendSnackBar("Error de conexión", "error"));
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    };

    const tipoNumero = (valor) => {
        let num = 0;

        switch(valor)
        {
            case "referencia":
                num = 1;
                break;
            case "telefono":
                num = 2;
                break
        }

        return num;
    };

    const buscar = (event) => {
        event.preventDefault();
        setLoad(true);

        limpiaValores();

        let busqueda = document.getElementById("busqueda").value;

        if(busqueda !== ""){
            Login()
            .then(result => {
                let params = {
                    Indicador: busqueda,
                    Tipo: tipoNumero(tipo),
                    Capturista: getUser()
                };

                ObtieneCapturas(result.token, params)
                .then(result => {
                    let capturas = result.capturas.map((element) => {
                        element.FechaCapturista = element.FechaCapturista === "" ? "" : moment(moment(element.FechaCapturista, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY");
                        return element;
                    });
                    setCapturas(capturas);
                    setLoad(false);

                }).catch(error => sendSnackBar("Error de conexión", "error"));
            }).catch(error => sendSnackBar("Error de conexión", "error"));
        } else {
            sendSnackBar("Debes agregar un elemento a buscar", "error");
            setLoad(false);
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const SnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenSnackbar(false);
    };

    const DialogClose = () => {
        setOpenDialog(false);
        limpiaValores();
    };

    const Login = async () => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
                headers: {
                    "Content-Type": "application/json"
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Login",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ActualizaCalificacion = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Calificacion/ActualizaCalificacion",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const InsertaPreguntas = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Calificacion/InsertaPreguntas",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const EliminaPreguntas = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Calificacion/EliminaPreguntas",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneRespuestas = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Calificacion/ObtieneRespuestas",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneCapturas = async (token, data) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Captura/ObtieneCapturas",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtienePreguntas = async (token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Preguntas/ObtienePreguntas",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneSiguiente = () => {
        setLoad(true);

        limpiaValores();
        setCapturas([]);

        Login()
        .then(result => {
            let params = {
                Tipo: 4,
                Capturista: getUser()
            };

            ObtieneCapturas(result.token, params)
            .then(result => {
                if(result.capturas.length > 0){
                    let cap = result.capturas[0];
                
                    setIdCaptura(cap.IdCaptura);
                    setFolio(cap.Folio);

                    setNombre(cap.Nombre);
                    setCosto(cap.Costo);
                    setCuenta(cap.Cuenta);
                    setNombreCapturista(cap.NombreCapturista);

                    setCelular(cap.Celular);
                    setComentarioVenta(cap.Comentario);
                    setFechaCapturista(cap.FechaCapturista);

                    setObservaciones(cap.Observacion);
                } else {
                    sendSnackBar("No hay registros pendientes de calificar", "error")
                }
                setLoad(false);
            }).catch(error => sendSnackBar("Error de conexión", "error"));
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    };

    const ValidaCalificacion = () => {
        let total = 0;
        let calificacionTotal = 0;
        let respondidas = 0;
        let resp = [];

        respuestas.map((item) => {
            if(item.s !== false || item.n !== false || item.na !== false){
                calificacionTotal = calificacionTotal + item.calificacion;
                respondidas++;
                resp.push({
                    IdCaptura: parseInt(IdCaptura),
                    IdPreguntas: parseInt(item.id),
                    Respuesta: item.s ? 1 : (item.n ? 2 : 3)
                });
            }
            
            if(item.s || item.na){
                total = total + item.calificacion;
            }
        });
        
        if(Math.sign(total) === -1 || total === 0){
            setTotal(0);
        } else {
            let result = total * 100 / calificacionTotal;
            setTotal(parseInt(result));
        }

        setTotalPreguntas(respondidas);
        setRespuestasEnviar(resp);
        setDialogSend(true);
    };

    const EnviaDatos = () => {
        try{
            setDialogSend(false);
            setLoad(true);
            
            let datosActualiza = { 
                IdCaptura: parseInt(IdCaptura), 
                Observacion: Observaciones, 
                FechaCalificacion: moment(Date.now()).toDate(), 
                Calificador: getUser(),
                Calificacion: parseInt(Total)
            };

            let eliminadas = respuestasOriginales.filter((item) => {
                return respuestasEnviar.find(element => element.IdPreguntas === item.IdPreguntas) === undefined;
            });

            eliminadas = eliminadas.map((item) => {
                item.IdCaptura = parseInt(IdCaptura);
                return item;
            });
            
            if(IdCaptura !== ""){
                Login()
                .then(result => {
                    if(result !== undefined){
                        ActualizaCalificacion(datosActualiza, result.token)
                        .then(result => {
                        }).catch(error => sendSnackBar("Error de conexión", "error"));

                        EliminaPreguntas(eliminadas, result.token)
                        .then(result => {
                        }).catch(error => sendSnackBar("Error de conexión", "error"));

                        InsertaPreguntas(respuestasEnviar, result.token)
                        .then(result => {
                            if(result.success){
                                sendSnackBar("Registro exitoso", "success");
                                setOpenSnackbar(true);
                                setOpenDialog(true);
                            } else {
                                sendSnackBar("Error de conexión", "error");
                            }
            
                            setLoad(false);
                        }).catch(error => sendSnackBar("Error de conexión", "error"));
                    } else {
                        sendSnackBar("Error de conexión", "error");
                        setLoad(false);
                    }
                }).catch(error => sendSnackBar("Error de conexión", "error"));
            } else {
                sendSnackBar("Debe seleccionar un cliente", "error");
                setLoad(false);
            }
        } catch(error){
            sendSnackBar("Error de conexión", "error");
            setLoad(false);
        }
    };

    const limpiaValores = () => {
        setIdCaptura("");
        setFolio("");

        setNombre("");
        setCosto("");
        setCuenta("");
        setNombreCapturista("");

        setCelular("");
        setComentarioVenta("");
        setFechaCapturista("");

        setObservaciones("");

        const res = preguntas.map((item) => {
            return {
                id: item.IdPreguntas,
                s: false,
                n: false,
                na: false,
                calificacion: item.Calificacion
            };
        });
        setRespuestas(res);
        setRespuestasOriginales([]);
        setCalificacion(0);
    };

    const UsuarioActivo = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Usuario/UsuarioActivo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }

        return dataResponse;
    };

    const GetIdUsuario = () => {
        return JSON.parse(localStorage.getItem('userCalidad')).IdUsuario;
    };

    const handleChange = (event, id, tipo) => {
        let nRespuestas = [...respuestas];
        
        if(tipo === 'S'){
            nRespuestas[id].s = event.target.checked;
            nRespuestas[id].n = false;
            nRespuestas[id].na = false;
            setRespuestas(nRespuestas);
        } else if(tipo === 'N'){
            nRespuestas[id].s = false;
            nRespuestas[id].n = event.target.checked;
            nRespuestas[id].na = false;
            setRespuestas(nRespuestas);
        } else if(tipo === 'NA'){
            nRespuestas[id].s = false;
            nRespuestas[id].n = false;
            nRespuestas[id].na = event.target.checked;
            setRespuestas(nRespuestas);
        }

        let total = 0;
        nRespuestas.map((item) => {
            if(item.s || item.na){
                total = total + item.calificacion;
            }
        });
        setCalificacion(total < 0 ? 0 : total);
    };

    useEffect(() => {
        Login()
        .then(result => {
            if(result !== undefined){
                let token = result.token;

                UsuarioActivo({ IdUsuario: GetIdUsuario() },token)
                .then(result => {
                    if(result.activo === false){
                        localStorage.removeItem("userCalidad");
                        return <Redirect to='/admin'/>;
                    }
                });

                ObtienePreguntas(token)
                .then(result => {
                    setPreguntas(result.preguntas);
                    const res = result.preguntas.map((item) => {
                        return {
                            id: item.IdPreguntas,
                            s: false,
                            n: false,
                            na: false,
                            calificacion: item.Calificacion
                        };
                    });
                    setRespuestas(res);
                }).catch(error => sendSnackBar("Error de conexión", "error"));
            } else {
                sendSnackBar("Error de conexión", "error");
            }
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    }, []);

    return (
        <>
            <Grid container>
                <Grid item xs={12} sm={12} xl={12}>
                    <Button
                        color="info"
                        variant="contained"
                        onClick={ObtieneSiguiente}
                        style={{ float: "left", marginBottom: "20px" }}
                        size="large"
                        >
                            { "Siguiente" }
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} xl={6}>
                    <Paper
                        style={{ marginBottom: "30px" }}
                        component="form"
                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                        >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Buscar..."
                            inputProps={{ 'aria-label': 'search google maps' }}
                            id="busqueda"
                        />
                        <IconButton onClick={buscar} sx={{ p: '10px' }} aria-label="search">
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} xl={6}>
                    <FormControl component="fieldset">
                        <RadioGroup row aria-label="gender" name="row-radio-buttons-group">
                            <FormControlLabel
                                checked={tipo === 'referencia'}
                                onChange={(event) => setTipo(event.target.value)}
                                value="referencia" 
                                control={<Radio />} 
                                label="Referencia" />
                            <FormControlLabel
                                checked={tipo === 'telefono'}
                                onChange={(event) => setTipo(event.target.value)}
                                value="telefono" 
                                control={<Radio />} 
                                label="Teléfono" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                { capturas.length > 0 && 
                    (
                        <Grid item xs={12} sm={12} xl={12} style={{ marginBottom: "30px" }}>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 440 }}>
                                    <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {capturas.map((row) => {
                                            return (
                                                <TableRow onClick={(e) => selectRow(e, row)} selected={row.select} hover={true} tabIndex={-1} key={capturas.IdCaptura}>
                                                    {columns.map((column) => {
                                                        return (
                                                            <TableCell key={column.id} align={column.align}>
                                                                {  
                                                                    row[column.id]
                                                                }
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 100]}
                                    component="div"
                                    count={capturas.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(event, newPage) => setPage(newPage)}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Grid>
                    )
                }
            </Grid>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6" style={{fontWeight: "bold"}}>
                            Datos
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Nombre del cliente:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {Nombre}
                        </Typography>                    
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Nombre del ejecutivo:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {NombreCapturista}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            TDC:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {Cuenta}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Folio:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {Folio}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Costo:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {Costo}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Fecha de captura:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {FechaCapturista}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Celular:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {Celular}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4} style={{display: "ruby"}}>
                        <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}>
                            Comentario venta:
                        </Typography>
                        <Typography variant="body1" gutterBottom style={{marginLeft: "20px"}}>
                            {ComentarioVenta}
                        </Typography>
                    </Grid>
                </Grid>
            </Card>     
            <Card style={{ marginBottom: "30px" }}>
                    <Grid container spacing={3} style={{ padding: "30px" }}>
                        <Grid item xs={12} sm={12} xl={12}>
                            <Typography variant="h6">
                                Preguntas
                            </Typography>
                        </Grid>
                        <Box
                            sx={{
                                '& > :not(style)': {
                                m: 1,
                                width: 128,
                                height: 128,
                                },
                            }}
                            style={{ position: "fixed", bottom: "20px" }}
                            >
                            <Paper elevation={3} style={{ margin: "auto", display: "flex", alignItems: "center", backgroundColor: Calificacion < 60 ? "#FF474D" : (Calificacion >= 60 && Calificacion < 80 ? "#fdfa72" : "#90ee90") }}>
                                <Typography variant="h2" style={{ margin: "auto" }}>{Calificacion}</Typography>
                            </Paper>
                        </Box>
                        {preguntas.map((column) => (
                            <Grid item xs={12} sm={12} xl={12} key={column.IdPreguntas}>
                                <Grid container>
                                    <Grid item xs={12} sm={6} xl={6} style={{borderColor: "#2196F3", display: "flex", backgroundColor: column.Calificacion === -100 ? "#fdfa72" : "#ddffff", borderLeft: "6px solid #2196F3", padding: "10px"}}>
                                        <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Pregunta}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={column.Calificacion === -100 ? 6 : 2} xl={column.Calificacion === -100 ? 6 : 2} style={{backgroundColor: "#d3f8d3", display: "flex"}}>
                                        <Checkbox 
                                            onChange={(event) => handleChange(event, column.IdPreguntas - 1, 'S')} 
                                            checked={respuestas[column.IdPreguntas - 1] == undefined ? false : respuestas[column.IdPreguntas - 1].s} 
                                            icon={<CheckCircleOutlineIcon />} 
                                            checkedIcon={<CheckCircleIcon color='green' />}
                                            style={{ margin: "auto" }}
                                            color="success"
                                        />
                                    </Grid>
                                    {
                                        column.Calificacion === -100 ? null : (
                                        <>
                                        <Grid item xs={12} sm={2} xl={2} style={{backgroundColor: "#ffefea", display: "flex"}}>
                                            <Checkbox
                                                onChange={(event) => handleChange(event, column.IdPreguntas - 1, 'N')} 
                                                checked={respuestas[column.IdPreguntas - 1] == undefined ? false : respuestas[column.IdPreguntas - 1].n} 
                                                icon={<HighlightOffIcon />} 
                                                checkedIcon={<CancelIcon />}
                                                style={{ margin: "auto" }}
                                                color="error"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2} xl={2} style={{backgroundColor: "#ffffc1", display: "flex"}}>
                                            <Checkbox
                                                onChange={(event) => handleChange(event, column.IdPreguntas - 1, 'NA')} 
                                                checked={respuestas[column.IdPreguntas - 1] == undefined ? false : respuestas[column.IdPreguntas - 1].na} 
                                                icon={<RemoveCircleOutlineIcon />} 
                                                checkedIcon={<DoDisturbOnIcon />}
                                                style={{ margin: "auto" }}
                                                color="warning"
                                            />
                                        </Grid>
                                        </>
                                        )
                                    }
                                </Grid>
                            </Grid>
                        ))}
                        <Grid item xs={12} sm={6} xl={6}>
                            <TextField label="Observaciones" value={Observaciones} onChange={(event) => setObservaciones(event.target.value)} variant="outlined" inputProps={{ maxlength: 255 }} style={{ width: "100%" }}></TextField>
                        </Grid>
                </Grid>
            </Card>
            <Grid container
                direction="row-reverse"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={12} sm={12} xl={3}>
                    <Button
                        color="info"
                        variant="contained"
                        onClick={ValidaCalificacion}
                        style={{ float: "right" }}
                        size="large"
                        >
                            { "Enviar" }
                    </Button>
                </Grid>
            </Grid>
            <Dialog
                open={openDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={DialogClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Registro exitoso"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {`Información enviada del folio: ${Folio}`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={DialogClose}>Aceptar</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogSend}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setDialogSend(false)}
                aria-describedby="dialog-calificacion"
            >
                <DialogTitle>{"Validar calificación"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="dialog-calificacion">
                        {`Preguntas contestadas: ${TotalPreguntas}`}
                        <br></br>
                        {`Calificación:  ${Total}`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={EnviaDatos}>Aceptar</Button>
                </DialogActions>
            </Dialog>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={SnackbarClose} autoHideDuration={6000}>
                <Alert onClose={SnackbarClose} severity={color} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            <Loader load={load} />
        </>
    );
}

export default Captura;